<!DOCTYPE html>
<html lang="tr-TR">
    <head>
        <title>CARDATA Türkiye'nin Lider Otomotiv Datası Şirketi</title>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        <base href="/">    
        <script src="assets/js/jquery-3.3.1.js"></script>
        <script src="assets/js/plugins/jquery.masknumber.min.js"></script> 
      </head>
<body>
<div class="page">
    <div class="container-fluid login">
		<div class="row">
			<div class="col-md-12">
			 <div class="box mt40 mb40 static">
				 <div class="row">
					<div class="col-lg-12">
						<div class="static-content">
							<img src="../../../assets/img/shared/a-big-data-company.png" />
							
							<p>CarData®, 2012 yılında kurulan CDI (Car Data International®) Otomotiv Bilgi Hizmetleri A.Ş.®’nin premium otomotiv veri ve teknoloji markasıdır.</p>

							<p>%100 Türk mühendisliğiyle geliştirilen CarData®, Türkiye otomotiv pazarının kendine özgü dinamiklerini, ileri veri teknolojileri ve yapay zekâ destekli analiz yetkinlikleriyle bir araya getirir. Türkiye’nin ilk otomotiv veri şirketi olarak; pazardaki 0 km ve ikinci el araçlara ilişkin doğru, güncel ve kapsamlı verileri sektör profesyonellerinin, kurumların ve bireysel kullanıcıların hizmetine sunar.</p>

							<p>CarData®; Türkiye’nin en kapsamlı marka, model ve versiyon veri tabanını, uzman analistlerinin sektörel deneyimi ve gelişmiş teknolojik altyapısıyla sürekli olarak zenginleştirir. Büyük veri, yapay zekâ ve özgün algoritmalarla işlenen otomotiv verilerini anlamlı içgörülere dönüştürerek müşterilerine ve iş ortaklarına 360 derece bağımsız veri çözümleri sağlar. Böylece kurumların risklerini daha etkin yönetmelerine, bilgiye dayalı doğru kararlar almalarına ve sürdürülebilir rekabet avantajı elde etmelerine katkıda bulunur.</p>

							<p>CarData®, otomotiv sektörünün dijital dönüşümüne yön veren ürün ve hizmetleriyle; verinin toplanmasından doğrulanmasına, işlenmesinden analiz edilmesine ve karar destek çözümlerine dönüştürülmesine kadar tüm süreçleri uçtan uca yönetir. Güçlü teknolojik altyapısı sayesinde doğru ve güncel otomotiv verilerini yüksek performanslı, güvenilir ve kesintisiz çözümlerle iş ortaklarına ulaştırır.</p>

							<p>İnovasyonu ve sürekli gelişimi temel yaklaşım olarak benimseyen CarData®, insan uzmanlığını yapay zekâ ve ileri teknolojiyle buluşturarak otomotiv verisinin geleceğini şekillendirir.</p>

							<p>2012 yılından beri faaliyette olan CarData®, Türkiye’nin lider otomotiv veri şirketidir.</p>

							<p><b>Bilgi; Güç, Değer ve Kârlılıktır!</b></p>
						</div>
					</div>
				 </div>
			 </div>
			</div>
		</div>
	</div>
</div>
<script src="js/plugins/owl.carousel.js" type="text/javascript"></script>
<script src="js/plugins/jquery.fancybox.js" type="text/javascript"></script>
<script src="js/plugins/sweetalert2.js" type="text/javascript"></script>
<script src="js/plugins/is.js" type="text/javascript"></script>
<script src="js/plugins/jquery.lazy.min.js" type="text/javascript"></script>
<script src="js/plugins/jquery.validate.min.js" type="text/javascript"></script>
<script src="js/plugins/messages_tr.js" type="text/javascript"></script>
<script src="js/app.js" type="text/javascript"></script>
<script src="js/plugins/jquery.marquee.min.js" type="text/javascript"></script>
</body>
</html>